import { Box, Modal, Typography, IconButton, Stack } from '@mui/material';
import { useCallback, useRef, useState } from 'react';
import { AttachmentResponseViewModel } from 'types/appointment';
import CloseIcon from '@mui/icons-material/Close';
import { Theme } from '@mui/material/styles';
import { AttachmentViewItem } from 'components/@shared/Attachments/AttachmentViewItem';

interface Props {
    list: AttachmentResponseViewModel[];
}

const boxStyles = {
    position: 'relative',
    backgroundColor: 'grey.300',
    maxWidth: '90vw',
    margin: 'auto',

    '& img': {
        maxWidth: '100%',
    },
};

const boxWrapper = (theme: Theme) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'auto',
    p: 5,
    [theme.breakpoints.only('xs')]: {
        p: 2,
    },
});

export const AttachmentsView = ({ list }: Props) => {
    const [image, setImage] = useState<{ name: string; url: string } | null>(null);

    const viewImageHandler = useCallback(
        (id: string) => {
            const info = list.find((item) => item.id === id);
            if (!info) {
                return;
            }
            setImage({ name: info.fileName, url: info.filePath });
        },
        [list],
    );

    const handleClose = useCallback(() => {
        setImage(null);
    }, []);

    return (
        <>
            <Stack gap={1} direction="row">
                {list.map((imageInfo) => (
                    <AttachmentViewItem key={imageInfo.id} {...imageInfo} onView={viewImageHandler} />
                ))}
            </Stack>
            {image && (
                <Modal
                    open={!!image}
                    onClose={handleClose}
                    aria-labelledby="image-modal-title"
                    aria-describedby="image-modal-description"
                >
                    <Box sx={boxWrapper}>
                        <Box sx={boxStyles}>
                            <Box
                                width="100%"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                pl={2}
                                pr={1}
                            >
                                <Typography id="image-modal-title" variant="h6" component="h2">
                                    {image.name}
                                </Typography>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <img src={image.url} alt="image" />
                        </Box>
                    </Box>
                </Modal>
            )}
        </>
    );
};
